import React from 'react';
import LocationTemplate from './LocationTemplate';

const OxfordPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Oxford"
      stateName="North Carolina"
      countyName="Granville"
      zipCodes={["27565"]}
      latitude={36.3104}
      longitude={-78.5931}
      population={8388}
      historicalFact="Known as the 'Grandest Little City in North Carolina,' famous for its historic tobacco warehouses."
      nearbyTowns={[
        "Henderson, NC",
        "Durham, NC",
        "Raleigh, NC",
        "Creedmoor, NC",
        "Butner, NC",
        "Louisburg, NC",
        "Wake Forest, NC",
        "Franklinton, NC"
      ]}
    />
  );
};

export default OxfordPage;